/**
 * @description: 动态导入hooks
 * @author wit
 */
import witNotify from '/@/utils/witNotify.ts'


export const $baseMessageTop: any = (
  message: string,
  type: 'primary' | 'success' | 'error' | 'warning' | 'danger' | 'info' = 'primary',
  top: number = 0,
) => {
  return witNotify({ message, type, top })
}

export const $baseMessage: any = (
  message: string,
  type: 'success' | 'error' | 'fail' | 'exception' | 'loading' | 'none' = 'none',
  callback?: any,
) => {
  return uni.showToast({
    title: message,
    icon: type,
    duration: 2000,
    mask: true,
    success: callback && callback(),
  })
}

export const $baseConfirm: any = (
  content: string,
  title: string,
  callback1: any,
  callback2: any,
  confirmButtonText = '确定',
  cancelButtonText = '取消',
) => {
  return uni.showModal({
    title: title,
    content,
    cancelText: cancelButtonText,
    confirmText: confirmButtonText,
    cancelColor: '#A3AAB4',
    confirmColor: '#2D60DD',
    success: function (res) {
      if (res.confirm) {
        callback1 && callback1()
      } else if (res.cancel) {
        callback2 && callback2()
      }
    },
  })
}
